import { Icon } from '@civilgrid/ui/components';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

interface Props {
  id?: string;
  /** Names the navigation landmark, e.g. "Project". */
  'aria-label': string;
  children: ReactNode;
  backButtonState?: Record<string, unknown>;
}

export default function LeftNav({ id, 'aria-label': ariaLabel, backButtonState = {}, children }: Props) {
  return (
    <nav
      id={id}
      aria-label={ariaLabel}
      className="h-screen-height-minus-top-nav flex w-56 flex-col border-r border-grey-30 bg-white"
    >
      <Link
        to="/home"
        state={backButtonState}
        data-testid="project-left-nav-home-link"
        className="group/backButton mx-2 my-2 flex cursor-pointer rounded-sm py-1 focus-ring"
      >
        <span className="flex items-center gap-1 font-noto text-sm font-normal text-blue-50 no-underline border-b border-transparent group-hover/backButton:border-blue-50">
          <Icon icon="arrowLeft" size={16} />
          <span>Home</span>
        </span>
      </Link>
      <div className="overflow-y-auto p-2 pb-24">{children}</div>
    </nav>
  );
}
